'use client';

import { Button, ButtonGroup, Flex, Heading, Text } from '@/_components';
import type { FC } from 'react';
import type { SentEnterpriseFormProps } from './SentEnterpriseForm.types';
import { FormStateType } from '../../EnterpriseDialog.types';
import { useRouter } from 'next/navigation';
import styles from './SentEnterpriseForm.module.css';

const FORM_TITLE: Record<FormStateType, string> = {
  'book-a-demo': 'Demo request confirmed!',
  'contact-sales': 'You’re all set!',
};

const FORM_DESCRIPTION: Record<FormStateType, string> = {
  'book-a-demo': "We'll reach out soon to find the best time for you.",
  'contact-sales':
    'Our team will be in touch soon to walk you through this feature.',
};

export const SentEnterpriseForm: FC<SentEnterpriseFormProps> = ({
  formState,
}) => {
  const { push } = useRouter();

  if (!formState) return null;

  const onHome = () => push('/');

  return (
    <Flex isColumn={true} isCentered={true} gap={12} padding={12}>
      <img
        className={styles.sentEnterpriseImage}
        src="/images/enterprise/SentEnterpriseFormIllustration.png"
        alt="Paper illustration depicting confirmed request"
      />
      <Flex isColumn={true} gap={2} isCentered={true}>
        <Heading level={3} color="success">
          {FORM_TITLE[formState]}
        </Heading>
        <Text textAlign="center" type="div">
          {FORM_DESCRIPTION[formState]}
        </Text>
      </Flex>
      <ButtonGroup align="center" isFullWidth={true} isSameLine={true}>
        <Button intent="primary" value="Back to Collect" onClick={onHome} />
      </ButtonGroup>
    </Flex>
  );
};
